import styled from '@emotion/styled';
import { space } from 'styled-system';
import { StyledProps } from './CloseBtn.types';
import { Theme } from '../Modal.types';
import css from '@styled-system/css';

export default styled.button<StyledProps, Theme>`
  ${space}
  ${css({
    height: '14px',
    width: '14px',
    cursor: 'pointer',
    position: 'absolute',
    right: 4,
    top: 4,
    outline: 'none',
    border: 'none',
    bg: 'transparent',
  })}
`;
